import RecentPaymentPageBody from '../components/recentPaymentPage/RecentPaymentPageBody'

const RecentInvoice = () => {
  return (
    <RecentPaymentPageBody/>
  )
}

export default RecentInvoice